export default __webpack_public_path__ + "static/media/Sweet-Day.ec0dd555.jpg";